import React from "react";
import "./VerifiedBadge.scss";

const VerifiedBadge = ({ className = "", title = "Verified analyst" }) => (
  <i
    className={["material-icons", "verified-badge", className]
      .filter(Boolean)
      .join(" ")}
    role="img"
    aria-label={title}
    title={title}
  >
    verified
  </i>
);

export default VerifiedBadge;
